// Version on /find-a-pub page
import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import RegionSelector from "./RegionSelector";
import Facilities, { facilitiesList } from "./Facilities";
import arrowIcon from "../../../images/right-arrow.png";
import { useSearchResultsStore } from "../../../services/store";

export default function FiltersFull({
  classes,
  loadData,
  prefillValues = {},
  hasMap = false,
}) {
  const [query, updateQuery] = useState(prefillValues.query);
  const [gettingLocation, setGettingLocation] = useState(false);
  const [regions, updateRegions] = useState(prefillValues.region || []);
  const [facilities, updateFacilities] = useState(() => {
    return facilitiesList.reduce((acc, facility) => {
      acc[facility.state] = prefillValues[facility.state] || false;
      return acc;
    }, {});
  });

  const {
    selectedRegions,
    searchQuery,
    setSearchQuery,
    searchRadius,
    setSearchRadius,
  } = useSearchResultsStore();

  useEffect(() => {
    if (searchRadius === 30) {
      setSearchRadius(5);
    }
  }, []);

  function clearFilters(e) {
    e.preventDefault();

    updateQuery("");
    updateFacilities(
      facilitiesList.reduce((acc, facility) => {
        acc[facility.state] = false;
        return acc;
      }, {})
    );
    setSearchRadius(5);
  }

  function handleSubmit(e) {
    e.preventDefault();

    const data = {
      query,
      radius: searchRadius,
      regions: selectedRegions,
      ...facilities,
    };

    loadData(data);
  }

  function getCurrentLocation() {
    if (navigator.geolocation) {
      setGettingLocation(true);
      navigator.geolocation.getCurrentPosition(async function(position) {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`
        )
          .then((response) => response.json())
          .then((data) => {
            const { city, postcode } = data.address;
            updateQuery(city || postcode);
            setSearchQuery(city || postcode);
            setGettingLocation(false);
          })
          .catch((error) => console.log(error));
      });
    } else {
      console.warn("Geolocation is not supported by this browser.");
    }
  }

  return (
    <Grid container direction="row">
      <Grid item xs={12}>
        <form
          className={hasMap ? classes.FormWithMap : classes.Form}
          onSubmit={handleSubmit}
        >
          <h3 className={classes.Legend}>Find a Pub</h3>
          <div className={`fields ${classes.Fields}`}>
            <div
              className={`${classes.Field} ${classes.Name}`}
              role="search"
              aria-disabled={selectedRegions.length > 0}
            >
              <label className={classes.Label} htmlFor="name">
                Search
              </label>
              <input
                className={classes.Input}
                type="search"
                name="query"
                placeholder="Pub Name or Town or Postcode"
                autoComplete="off"
                defaultValue={searchQuery ?? query}
                onChange={(e) => {
                  updateQuery(e.target.value);

                  setSearchQuery(e.target.value);
                }}
              />
              <button
                type="button"
                onClick={getCurrentLocation}
                data-loading={gettingLocation}
              >
                {gettingLocation ? "loading" : "get current"}
              </button>
            </div>
            {!hasMap && (
              <div className={classes.Field}>
                <label className={classes.Label} htmlFor="radius">
                  Radius
                </label>
                <select
                  className={`${classes.Input} ${classes.Radius}`}
                  id="radius"
                  name="radius"
                  value={searchRadius}
                  onBlur={(e) => {
                    setSearchRadius(e.target.value);
                  }}
                  onChange={(e) => {
                    setSearchRadius(e.target.value);
                  }}
                >
                  {[5, 10, 15, 20, 25, 50, 100].map((r, i) => (
                    <option value={r} key={i}>{`${r} Miles`}</option>
                  ))}
                </select>
              </div>
            )}
            <div className={`or`}>Or</div>
            <div
              className={classes.Field}
              aria-disabled={searchQuery.length > 0}
            >
              {/* regions */}
              <label className={classes.Label} htmlFor="regions">
                Regions
              </label>
              <RegionSelector
                parentClasses={classes}
                state={regions}
                setState={updateRegions}
                hasMap={hasMap}
              />
            </div>
            {!hasMap && (
              <div className={`${classes.Field} ${classes.Submit}`}>
                <button type="submit" className={classes.Button}>
                  search
                  <img src={arrowIcon} alt="Search" width={14} height={15} />
                </button>
              </div>
            )}
          </div>
          <Facilities
            classes={classes}
            prefillValues={facilities}
            updateFacilities={updateFacilities}
            clearFilters={clearFilters}
            hasMap={hasMap}
          />
        </form>
      </Grid>
    </Grid>
  );
}
